import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import Button from 'react-bootstrap/lib/Button';
import Collapse from 'react-bootstrap/lib/Collapse';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from '../../Link/Link';
import { DownArrowIcon } from '../../Common/Assets/SvgIconComponent/SideMenuIcons';
import s from './SideMenuAccordion.css';

// Helper to determine if the current path is active
function isActive(location, path, matchType = 'exact') {
  if (!location || !path) return false;

  switch (matchType) {
    case 'exact':
      return location === path;
    case 'startsWith':
      return location.startsWith(path);
    case 'regex':
      try {
        const regex = new RegExp(path);
        return regex.test(location);
      } catch (err) {
        console.error('Invalid regex path:', path);
        return false;
      }
    default:
      return false;
  }
}

function SideMenuAccordion({ dataValue, location, onClick, intl }) {
  const { formatMessage } = intl;

  // Determine if any child path is active
  const isMenuActive = dataValue?.paths?.some(path =>
    isActive(location, path, dataValue.matchType || 'exact')
  );

  // Open menu if current location is active
  const [isOpen, setOpen] = useState(isMenuActive);

  useEffect(() => {
    if (isMenuActive) {
      setOpen(true);
    }
  }, [isMenuActive]);

  return (
    <div>
      <div className={s.sideMenuAccordionHeader}>
        <Button onClick={() => setOpen(!isOpen)} className={cx(s.sideMenuAccordionHeaderBtn, isMenuActive && s.sideMenuAccordionHeaderActiveBtn)}>
          <span className={s.sideMenuAccordionItemIconContainer}>
            {dataValue?.icon}
          </span>
          <span className={s.sideMenuAccordionItemTextContainer}>
            {formatMessage({ id: dataValue?.label })}
          </span>
          <span className={cx(s.sideMenuAccordionItemArrow, isOpen && s.sideMenuAccordionItemActiveArrow)}>
            <DownArrowIcon />
          </span>
        </Button>
      </div>

      <Collapse in={isOpen}>
        <div>
          {dataValue?.data?.map((value, key) => {
            const activeLink = value?.activePaths?.some(path =>
              isActive(location, path, value.matchType || 'exact')
            );

            return (
              <div key={key}>
                <Link
                  to={value?.href}
                  onClick={onClick}
                  className={cx(s.sideMenuAccordionCollapseItem, activeLink && s.sideMenuAccordionCollapseItemActive)}
                >
                  <span className={cx(s.sideMenuAccordionCollapseItemIcon, 'sideMenuAccordionCollapseItemIconRtl')}>{value?.icon}</span>
                  <span className={s.sideMenuAccordionCollapseItemText}>{formatMessage({ id: value?.label })}</span>
                </Link>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
}

export default injectIntl(withStyles(s)(SideMenuAccordion));